<script setup lang="ts">
import { Popover } from '../../ui/popover'

export interface DataTableCellPopoverRootProps {
  open?: boolean
}

const props = defineProps<DataTableCellPopoverRootProps>()

// eslint-disable-next-line vue/no-dupe-keys
const open = defineModel<boolean>('open')
</script>

<template>
  <Popover v-model:open="open">
    <slot />
  </Popover>
</template>
